import React from 'react';
import { motion } from 'framer-motion';
import { Lock, Clock, Zap } from 'lucide-react';
import { Button } from './Button';
export function Offer() {
  return <section id="oferta" className="py-20 bg-palomitas-beige/50 relative overflow-hidden" data-id="element-87">
      <div className="absolute -top-20 left-1/2 w-96 h-96 bg-palomitas-gold/10 rounded-full blur-3xl" data-id="element-88"></div>

      <div className="container px-4 mx-auto max-w-3xl relative z-10" data-id="element-89">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-[2rem] p-8 md:p-12 shadow-2xl border-4 border-palomitas-gold relative overflow-hidden" data-id="element-90">
          {/* Discount Badge */}
          <div className="absolute top-6 right-[-30px] bg-palomitas-coral text-white font-bold py-2 px-12 transform rotate-45 shadow-lg text-sm" data-id="element-91">
            75% OFF
          </div>

          {/* Colorful top accent */}
          <div className="absolute top-0 left-0 right-0 h-2 bg-palomitas-coral" data-id="element-92"></div>

          <div className="text-center mb-8" data-id="element-93">
            <div className="inline-flex items-center gap-2 bg-red-100 text-red-700 px-5 py-2.5 rounded-full font-bold mb-6 animate-pulse" data-id="element-94">
              <Clock size={20} data-id="element-95" />
              <span data-id="element-96">😱 Promoción solo por HOY</span>
            </div>

            <h2 className="text-4xl md:text-5xl font-bold text-palomitas-brown mb-4" data-id="element-97">
              Tu Negocio de Palomitas
            </h2>
            <p className="text-xl text-gray-600" data-id="element-98">
              Programa Completo + 7 Bonos Exclusivos
            </p>
          </div>

          <div className="bg-palomitas-emerald/10 rounded-2xl p-8 text-center mb-8 border-2 border-palomitas-emerald/20" data-id="element-99">
            <p className="text-gray-500 text-xl line-through mb-2" data-id="element-100">
              Precio original: $38.000
            </p>
            <div className="flex justify-center items-baseline gap-2" data-id="element-101">
              <span className="text-5xl md:text-7xl font-bold text-palomitas-emerald" data-id="element-102">
                $17.900
              </span>
              <span className="text-xl text-gray-600 font-medium" data-id="element-103">ARS</span>
            </div>
            <div className="inline-flex items-center gap-1 mt-3 text-palomitas-emerald font-bold text-lg" data-id="element-104">
              <Zap size={20} data-id="element-105" />
              <span data-id="element-106">¡Ahorrás $28.500!</span>
            </div>
          </div>

          <div className="flex flex-col items-center gap-6" data-id="element-107">
            <Button href="https://cocinaydulcesrentables.com/cart/54079623528732:1" className="w-full text-2xl py-6 shadow-xl shadow-palomitas-gold/30" data-id="element-108">
              👉 Quiero mi acceso
            </Button>

            <div className="flex items-center gap-2 text-gray-600 font-medium" data-id="element-109">
              <Lock size={20} className="text-palomitas-gold" data-id="element-110" />
              <span data-id="element-111">🔐 Acceso de por vida + actualizaciones</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}